import { useLanguage } from "@/contexts/LanguageContext";
import { SetupWizard } from "@/components/SetupWizard";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
export default function SetupCheck() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  useDocumentMeta("Kostenloser Setup-Check | CYPRUS PRIVÉ", "Beantworte wenige Fragen zu deinem Nordzypern-Vorhaben und erhalte eine persönliche Einschätzung zum nächsten Schritt.", true);
  return <main className="paper-grain bg-[#F7F3EB] py-16 sm:py-24"><div className="container"><div className="mx-auto mb-10 max-w-3xl text-center"><p className="eyebrow">{tx("KOSTENLOS UND UNVERBINDLICH")}</p><h1 className="mt-4 display-md font-semibold">{tx("WELCHES SETUP PASST ZU DEINEM VORHABEN?")}</h1><p className="mt-5 leading-8 text-[#66615A]">{tx("In wenigen Schritten verstehen wir dein Ziel, deinen Zeitrahmen und die Themen, die für dich relevant sind.")}</p></div><SetupWizard /></div></main>;
}
